import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewChart = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M42.375 37.827H10.173V5.625H5.625v36.75h36.75z" }), /* @__PURE__ */ _jsx("path", { d: "M31.089 31.629a4.139 4.139 0 1 0 0-8.278 4.139 4.139 0 0 0 0 8.278M17.506 20.345a4.139 4.139 0 1 0 0-8.278 4.139 4.139 0 0 0 0 8.278m19.853-5.743a4.14 4.14 0 1 0 0-8.278 4.14 4.14 0 0 0 0 8.278" })] }) })
});
export default SvgViewChart;
